'use client'

import Link from '@/components/link-locale'
import { useBanners } from '@/lib/api/hooks/use-banners'
import { Banner } from '@/types/banner'
import { AnimatePresence, motion } from 'framer-motion'
import { useRef, useState } from 'react'
import { Swiper as SwiperType } from 'swiper'
import 'swiper/css'
// import required modules
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react'

import Loading from './loading'
import NoData from './no-data'

export function Banners() {
  const { data: banners, isLoading } = useBanners({
    params: {
      sortField: 'display_order',
      sortOrder: 'ASC',
    },
  })

  const swiperRef = useRef<SwiperRef>(null)

  const hasBanners = (banners && banners?.length > 0) || false

  const [activeIndex, setActiveIndex] = useState(0)

  const handleSlideChange = (swiper: SwiperType) => {
    setActiveIndex(swiper.activeIndex)
  }

  const handlePaginationClick = (index: number) => {
    if (!swiperRef.current) return
    setActiveIndex(index)
    swiperRef.current?.swiper.slideTo(index)
  }

  return (
    <Loading isLoading={isLoading}>
      <NoData hasData={hasBanners}>
        <section>
          <div className='relative w-full'>
            <Swiper
              ref={swiperRef}
              className='homeSwiper'
              pagination={{
                dynamicBullets: true,
              }}
              modules={[Pagination]}
              spaceBetween={20}
              slidesPerView={'auto'}
              onSlideChange={handleSlideChange}
            >
              {banners?.map((item: Banner, index: number) => {
                // const bannerJsOptions = {
                //   controls: false,
                //   autoplay: false,
                //   muted: true,
                //   sources: [
                //     {
                //       src: item.previewVideo.url,
                //       type: 'application/x-mpegURL',
                //     },
                //   ],
                // }
                return (
                  <SwiperSlide
                    key={index}
                    className='!h-[209px] !w-full overflow-hidden border border-[#333742] md:!h-[515px] md:!w-[916px] lg:rounded-3xl'
                  >
                    <div className='relative w-full overflow-hidden lg:rounded-3xl'>
                      <Link href={item.linkUrl}>
                        <img
                          src={item.image.url}
                          alt={item.title}
                          className='h-full w-full object-cover'
                        />
                      </Link>
                      {/* {!!item.description && (
                        <div className='absolute bottom-0 left-0 z-20 max-h-[68px] max-w-[478px] rounded-tr-3xl bg-black bg-opacity-20 py-3 pl-5 pr-[70px]'>
                          <Text className='!text-sm font-bold leading-5 tracking-wide text-[#F9F9F9] lg:!text-base lg:leading-[22.4px]'>
                            {item.description}
                          </Text>
                        </div>
                      )} */}
                    </div>
                  </SwiperSlide>
                )
              })}
            </Swiper>

            <AnimatePresence>
              {banners && activeIndex !== banners.length - 1 && (
                <motion.div
                  className='pointer-events-none absolute right-0 top-0 z-10 hidden h-full w-[420px] bg-gradient-to-l from-black to-transparent lg:block'
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3, ease: 'easeOut' }}
                />
              )}
            </AnimatePresence>
          </div>

          {/* 自訂 Pagination */}
          <div className='mt-5 flex justify-center gap-x-2'>
            {banners?.map((_, index) => (
              <button
                key={index}
                className={`h-2.5 rounded-full transition-all ${
                  index === activeIndex
                    ? 'w-10 bg-[#F9F9F9]'
                    : 'w-2.5 bg-[#595968]'
                }`}
                onClick={() => handlePaginationClick(index)}
              />
            ))}
          </div>
        </section>
      </NoData>
    </Loading>
  )
}
